<template lang="pug">

</template>

<script>
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
export default {
  data () {
    return {

    };
  },
  computed: {
    // 外部
    isOut() {
      return window.location.href.indexOf("jsName=BimEx") !== -1;
    }
  },
  created () {
    this.queryUrl();
  },
  methods: {
    /** 外部流程处理
     * url参数
     * @param approveType  新增:"add"; 审批:"edit"; 查看:"view";暂存: "draft"; 重新发起:"again"
     * @param currentVersionId, 当前版本
     * @param flowDefinitionId 流程定义id
     * @param flowKey 流程key
     * @param businessId 草稿id/暂存id :approveType为draft 必填
     * @param flowInstanceId approveType为edit,view,again 必填
     * @param enterpriseId 企业id
     * @param list 文件列表信息
     * @param prjId 项目id
     *
     */
    queryUrl () {
      const { list, enterpriseId, prjId, isProject, clientType } = this.$route.query;
      const ct = clientType ? (clientType === '2D' ? 1 : (clientType === '3D' ? 2 : Number(clientType))) : 0;
      const data = { ...this.$route.query, fileInfoList: list && Array.isArray(JSON.parse(list)) ? JSON.parse(list) : [], enterpriseId, prjId, fullscreen: true,
        isProject: !!isProject, clientType: ct };
      openFlow(data);
    }
  }
};
</script>

<style>

</style>
